/**
 * PostHog feature-flag hooks, one file per flag.
 *
 * House rules for every hook in this folder:
 *  - export the flag KEY as a constant next to the hook, so specs and stubs reference the same
 *    string as the runtime;
 *  - default to FALSE: `useFeatureFlagEnabled` returns `undefined` while flags load and
 *    whenever PostHog is absent (local dev, CI, ad blockers), and a gated feature must hide,
 *    not flash, in those cases;
 *  - document what the flag gates and why, so a future "can we delete this flag?" audit does
 *    not require archaeology.
 */
export {
  MICROSOFT_SSO_FEATURE_FLAG,
  useMicrosoftSsoFeature,
} from './useMicrosoftSsoFeature'
export {
  STATE_SSO_FEATURE_FLAG,
  useStateSsoFeature,
} from './useStateSsoFeature'
export {
  useWhiteLabelFeature,
  WHITE_LABEL_FEATURE_FLAG,
} from './useWhiteLabelFeature'
